<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/logo.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          Welcome to Fire Watch 101
        </h1>

        <p class="subheading font-weight-regular">
          Fire Watch 101 provides easy-to-use software which offers alerting and incident info features for fire and EMS services in south eastern PA.
          <br>
          Create an account to get started.
          <br><br>Current supported counties:
          <ul>
            <li>Lancaster County PA</li>
            <li>Schuylkill County PA (Fire Only)</li>
          </ul>
        </p>
      </v-col>
      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Links:
        </h2>

        <v-row justify="center">
          <a
            v-for="(eco, i) in links"
            :key="i"
            :href="eco.href"
            class="subheading mx-3"
          >
            {{ eco.text }}
          </a>
        </v-row>
      </v-col>
          <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          Contact Us:
        </h2>

        <center>
        <a :href="`mailto:${supportEmail}`">{{supportEmail}}</a>
        </center>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HelloWorld',

    data: () => ({
      supportEmail: "support@firewatch101.com",
      links: [
        {
          text: 'Login',
          href: '/login',
        },
        {
          text: "Create an Account",
          href: '/create-account'
        }
      ]
    }),
  }
</script>
<style scoped>
ul{
  text-align: center;
  list-style-position: inside;
}
</style>
